import { useEffect } from 'react';

import { showNominatePeersSidePanelAction, hideNominatePeersSidePanelAction } from 'actions/nominatePeers';
import usePrevious from 'components/usePrevious';
import { useSelector, shallowEqual } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { selectNominatePeers } from 'selectors/nominatePeers';

import { getQueryParams } from 'constants/helper';

import { getEmployeeDetails } from 'services/employee';
import { showErrorSnackbar } from 'services/snackbar';

const useNominatePeersLinkState = ({ dispatch }) => {
  const history = useHistory();
  const { location } = history;
  const queryString = location.search;
  const currentPath = location.pathname;
  const { display, closingStatus } = useSelector(selectNominatePeers, shallowEqual);
  const previousQueryString = usePrevious(queryString);

  useEffect(() => {
    const getDetailsFromRoute = () => {
      const { showNominatePeers, reviewId, empId } = getQueryParams(queryString);
      const areNominatePeersRouteAndReviewIdPresent = showNominatePeers === 'true' && reviewId;
      return { areNominatePeersRouteAndReviewIdPresent, reviewId, empId };
    };
    if (queryString === previousQueryString) return;
    const { reviewId, areNominatePeersRouteAndReviewIdPresent, empId } = getDetailsFromRoute();
    if (areNominatePeersRouteAndReviewIdPresent) {
      if (!display) {
        if (!empId) {
          dispatch(showNominatePeersSidePanelAction({ reviewId }));
        } else {
          getEmployeeDetails(empId)
            .then((employee) => {
              dispatch(
                showNominatePeersSidePanelAction({
                  reviewId,
                  empId,
                  headerText: `Nominate peers for ${employee?.firstName}'s review`,
                })
              );
            })
            .catch((err) => {
              console.error('Error in opening nomination panel : ', err);
              dispatch(showErrorSnackbar('Error in opening nomination panel'));
            });
        }
      }
    } else if (display)
      dispatch(
        hideNominatePeersSidePanelAction({
          closingStatus,
        })
      );
  }, [queryString, previousQueryString, currentPath, dispatch, display, closingStatus]);
};

export default useNominatePeersLinkState;
